import { createFileRoute } from '@tanstack/react-router';
import ProvidedJobPostListDetailTemplate from '@/features/agent/provided_job_post_lists/templates/ProvidedJobPostListDetailTemplate';

export const Route = createFileRoute('/agent/provided_job_post_lists/$listId/')({
  component: ProvidedJobPostListDetail,
});

function ProvidedJobPostListDetail() {
  const { listId } = Route.useParams();
  return <ProvidedJobPostListDetailTemplate listId={listId} />;
}
